import { inject } from '@angular/core';
import type { SafeResourceUrl } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

export function walkthroughSanitizedVideoResolver(url: string): SafeResourceUrl {
  const domSanitizer = inject(DomSanitizer);
  // eslint-disable-next-line ban/ban
  return domSanitizer.bypassSecurityTrustResourceUrl(url);
}
